(function() {
  'use strict';

  function EventViewController(
    $scope,
    $rootScope,
    $translate,
    Event,
    Events,
    RouterHelper,
    // Replaced Router with RouterHelper
    Utils,
    Auth,
    Api,
    EVENT_STATES,
    LocalizationService
  ) {
    var ctrl = this;
    ctrl.displayView = 'default';

    var setEventViewOptions = function() {
      ctrl.event.getProgress();
      ctrl.authorized = true;
      ctrl.formOptions.readOnly = true;
      ctrl.actionButtons = ctrl.event.actionButtons;
      ctrl.actionButtons.push({
        label: $translate.instant('Back'),
        back: true,
        type: 'link',
        icon: 'icon-left-open-big',
        color: 'primary'
      });

      if (ctrl.event.isComplete()) {
        ctrl.displayView = ctrl.event.eventType.defaultView || 'default';
        var currentDate = new Date();
        var currentDateString = currentDate.toISOString().slice(0, 10).replace(/-/g, '_');
        ctrl.pdfUrl = ctrl.event.eventType.name.replace(/ /g, '_') + '_' + currentDateString;
        if (ctrl.displayView !== 'default') {
          ctrl.availableViews = [
            { id: ctrl.displayView, label: $translate.instant('Report view') }
          ];

          ctrl.event.checkPermission('canEditAny')
            .then(function() {
              ctrl.availableViews.push({
                id: 'default',
                label: $translate.instant('Full event view')
              });
            });
        } else {
          ctrl.availableViews = [
            { id: 'default', label: $translate.instant('Full event view') }
          ];
        }
      }

      // Run this just if accessed from tear off page
      // for normal event it is fetch from the directive that is displaying it
      if (
        ctrl.tearoff &&
        ctrl.event.currentSection.def &&
        ctrl.event.currentSection.def.multiSource
      ) {
        // Not returning on purpose as this does not need to slow down loading
        ctrl.event.getSectionTokens(ctrl.event.currentSection._id)
          .then(function(data) {
            ctrl.tokens = _.map(data, function(token) {
              return {
                url: Api.absHostUrl('token_url', { token: token.short_token })
              };
            });
          })
          .catch(function(err) {
            console.log(err);
          });
      }
    };

    function loadEvent(eid) {
      if (ctrl.currentEventExists) {
        setEventViewOptions();
      } else {
        ctrl.event.load(eid, ctrl.user, ctrl.token, ctrl.action === 'edit')
          .then(function() {
            return ctrl.event.containsGoalInCurrentSection();
          })
          .then(function() {
            if (ctrl.action === 'edit') {
              return ctrl.event.noPending();
            }
          })
          .then(setEventViewOptions)
          .catch(function(error) {
            if (error && error.status && error.status === 403) {
              Utils.unauthorized(error);
              return;
            }

            Utils.showError(error);
          });
      }
    }

    ctrl.$onInit = function() {
      if (ctrl.action === 'redirect') {
        Events.findFor(ctrl.eventId).then(function(event) {
          RouterHelper.navigate(
            ['/users/edit', event.doc.user, 'events', event.doc._id]
            , { replaceUrl: true }
          );
        });
        return;
      }
      ctrl.dateFormat = LocalizationService.getDateTimeFormat('dateonly');
      ctrl.EVENT_STATES = EVENT_STATES;
      ctrl.extraIsExpanded = ctrl.scrollTo === 'tags' ||
                            ctrl.scrollTo === 'documents';

      ctrl.action = 'view';
      ctrl.username = ctrl.user || Auth.currentUser();
      ctrl.formOptions = {};

      ctrl.auditLogShown = false;

      ctrl.currentEventExists = (
        !_.isEmpty(ctrl.eventObj) &&
        ctrl.eventObj.doc._id === ctrl.eventId
      );

      // Create an event object at the top so that binding is easier
      ctrl.event = ctrl.currentEventExists ? ctrl.eventObj : new Event({});

      $rootScope.$broadcast('KZCurrentEventChange', { event: ctrl.event });

      // We have to broadcast the formControll only when initialized and it's done only after
      // the form element (directive) is processed
      // $scope.$watch('eventCtrl.form', function(form) {
      //   if (form !== undefined) {
      //     $rootScope.$broadcast('KZCurrentFormChange', { form: form });
      //   }
      // });

      // If action is edit and we don't have state params redirect back
      if (['edit', 'view'].indexOf(ctrl.action) !== -1) {
        if (!ctrl.eventId) {
          // FIXME
          Utils.go(['/events/list'], { tryBack: true });
        } else {
          loadEvent(ctrl.eventId);
        }
      } else if (ctrl.eventId) {
        // FIXME
        Utils.go(['/events/list'], { tryBack: true });
      }
    };

    $scope.$on('KZItemRemoved', function() {
      if (ctrl.username === ctrl.event.doc.user) {
        Utils.go(['/events/list'], { tryBack: true });
      } else {
        return Utils.go(['/users/edit', ctrl.username, 'events'], { tryBack: true });
      }
    });

    $scope.$on('EventReload', function(_evt, args) {
      if (ctrl.event.doc !== undefined && args.id === ctrl.event.doc._id) {
        ctrl.updateEvent();
      }
    });

    ctrl.updateEvent = function() {
      console.log('Reloading event');
      return ctrl.event.reload()
        .then(function() {
          loadEvent(ctrl.event.doc._id);
        });
    };
  }

  EventViewController.$inject = [
    '$scope',
    '$rootScope',
    '$translate',
    'EventFactory',
    'EventsService',
    'RouterHelperService',
    'UtilsService',
    'AuthService',
    'ApiService',
    'EVENT_STATES',
    'LocalizationService'


  ];

  angular.module('component.events')
    .controller('EventViewController', EventViewController);
})();
